import styled from 'styled-components';

import { device } from 'config/device';

const Button = styled.button`
  padding: 8px 20px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: ${(props) => props.theme.border.button};
  font-weight: 600;
  font-family: 'Roboto';
  font-size: ${(props) => props.theme.small};
  color: #fff;
  letter-spacing: 1.2px;
  background: ${({ theme }) => theme.special};
  box-shadow: ${(props) => props.theme.shadow[2]};
  ${({ disabled }) => {
    if (disabled) {
      return { opacity: 0.4, cursor: 'not-allowed' };
    }
    return { opacity: 1, cursor: 'pointer' };
  }}
  :hover {
    ${({ disabled }) => {
      if (disabled) return {};
      return { opacity: 0.8 };
    }}
  }
  :focus {
    outline: none;
  }

  &.noHeight {
    height: auto;
  }
`;

type SecondaryButtonProps = {
  size?: 'sm' | 'lg';
};

const SecondaryButton = styled(Button)<SecondaryButtonProps>`
  padding: ${(props) => (props.size === 'sm' ? '0.8rem 2rem' : '1.5rem 3.2rem')};
  display: flex;
  align-items: center;
  font-weight: 500;
  color: ${(props) => props.theme.special};
  border: 2px solid ${({ theme }) => theme.special};
  background: transparent;
  box-shadow: ${(props) => props.theme.shadow[2]};

  @media ${device.mobile} {
    padding: 8px 12px;
  }
`;

const ActionButton = styled(Button)<SecondaryButtonProps>`
  padding: ${(props) => (props.size === 'sm' ? '4px 12px' : '1.5rem 5.2rem')};
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.special};
  border-radius: 12px;
  height: 3rem;

  /* Only apply text wrapping prevention to New button */
  &.new-button {
    white-space: nowrap; /* Prevent text wrapping */

    @media ${device.mobile} {
      padding: 4px 8px; /* Reduce padding on mobile */
      min-width: fit-content; /* Ensure button fits content */
    }
  }
`;

export { Button, SecondaryButton, ActionButton };
